
const MediaSection = () => {
  const mediaItems = [
    {
      title: '纽约时报',
      description: '全世界最有影响力的媒体之一《纽约时报》报道我们',
      icon: 'ri-newspaper-line',
      image: 'https://public.readdy.ai/ai/img_res/7c7d95fe310648957d71279965164eca.jpg'
    },
    {
      title: '人民日报',
      description: '荣登人民日报，被誉为"教育行业创新标杆"',
      icon: 'ri-newspaper-line',
      image: 'https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/b9994bfe46883c08c2236ab799dfa8b9.jpeg'
    },
    {
      title: '315认证',
      description: '荣获"年度值得信赖教育奖"',
      icon: 'ri-award-line',
      image: 'https://readdy.ai/api/search-image?query=Professional%20award%20certificate%20for%20trusted%20education%20services%2C%20golden%20award%20trophy%20with%20certificate%2C%20prestigious%20recognition%20ceremony%2C%20clean%20background%20with%20blue%20and%20gold%20tones&width=400&height=300&seq=award-315&orientation=landscape'
    },
    {
      title: 'LinkedIn官方合作',
      description: '全球最大求职平台LinkedIn领英官方合作方',
      icon: 'ri-linkedin-fill',
      image: 'https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/345bc33662cbf69e1a3a653d79695249.webp'
    },
    {
      title: 'BOSS直聘官方合作',
      description: '国内最大招聘平台官方合作伙伴',
      icon: 'ri-briefcase-line',
      image: 'https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/c71fe3a9d55e3b479efabf2ada2821c7.png'
    },
    {
      title: '招生委员会成员',
      description: '美国大学招生咨询协会成员/英联邦大学招生委员会成员',
      icon: 'ri-team-line',
      image: 'https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/83bf1618173f3ade8ca1c64643184d0d.png'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            主流媒体的赞誉与奖项
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            权威媒体认可，政府机构认证，行业领军地位获得广泛赞誉
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {mediaItems.map((item, index) => (
            <div key={index} className="group bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 border border-gray-100">
              <div className="relative overflow-hidden">
                <img 
                  src={item.image}
                  alt={item.title}
                  className="w-full h-24 md:h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2 md:top-4 md:left-4 w-6 h-6 md:w-12 md:h-12 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center">
                  <i className={`${item.icon} text-blue-600 text-xs md:text-xl`}></i>
                </div>
              </div>
              
              <div className="p-3 md:p-6">
                <h3 className="text-xs md:text-xl font-bold text-gray-900 mb-1 md:mb-3">
                  {item.title}
                </h3>
                <p className="text-xs md:text-base text-gray-600 leading-relaxed">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MediaSection;
